import { useEffect, useState } from "react";
import FormHeader from "./component/FormWallet";
import { getUser } from "../../config/LiveApi";
import { useSelector } from "react-redux";

function WalletUpload() {
  const token = useSelector((store) => store.userReducer.token);

  const [listofusers, setListofUser] = useState(null);

  const fetchUsers = async (page) => {
    try {
      const response = await getUser(token);
      const data = response?.data;

      const adminUsers = data.filter((user) => user.role === "admin");

      setListofUser(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <FormHeader listofusers={listofusers} />
    </div>
  );
}

export default WalletUpload;